import { isly } from "isly";
import { Date } from "../Date";
export var Numeric;
(function (Numeric) {
    var _a;
    Numeric.values = [1, 2, 3, 4, 5, 6, 7];
    _a = isly
        .number("value", ...Numeric.values)
        .rename("isoly.DayOfWeek.Numeric")
        .bind(), Numeric.type = _a.type, Numeric.is = _a.is, Numeric.flawed = _a.flawed;
    function from(date) {
        return (((Date.getWeekDay(date) + 7 - 1) % 7) + 1);
    }
    Numeric.from = from;
})(Numeric || (Numeric = {}));
//# sourceMappingURL=Numeric.js.map